import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import apiClient from "src/utils/apiClient";

export interface FeatureFlags {
    opsLive: boolean;
}

interface FeatureFlagsState {
    flags: FeatureFlags;
    loading: boolean;
}

const initialState: FeatureFlagsState = {
    flags: {
        opsLive: false,
    },
    loading: false,
}

export const fetchFeatureFlags = createAsyncThunk(
    "featureFlags/fetchFeatureFlags",
    async () => {
        const response = await apiClient.get("/feature-flags");
        return { opsLive: response.data.ops_live}
    }
)

const featureFlagsSlice = createSlice({
    name: "featureFlags",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchFeatureFlags.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchFeatureFlags.fulfilled, (state, action) => {
                state.flags = action.payload;
                state.loading = false;
            })
            .addCase(fetchFeatureFlags.rejected, (state) => {
                state.loading = false
            });
    },
});

export default featureFlagsSlice.reducer;
